module.exports = __webpack_public_path__ + "static/media/Rachel K.828fb9da.jpeg";